 <template>
  <div class="box4">
    <img src="../../../assets/coursePage/mba/box4/img01.png"/>
  </div>
</template>

<script>

export default {
  components: {
  
  },
  mounted() {},
  data() {
    return {
      
    };
  },
  
};
</script>

<style lang="less" scoped>
.box4 {
  width:100%;
img{
  width:100%;
}
  
}
</style>
